import { FC } from 'react'
import { Card } from 'antd'
import PerText from '../Text'
import PerFlexRow from '../FlexRow'
import PerButtonCircle from '../ButtonCircle'
import { Colors, TShirtSize } from '../../util/types'
import { icons } from '../Icon/icons'
import PerSpacer from '../Spacer'
import './index.less'

type Props = {
  heading: string
  description?: string
  icon?: {
    name?: keyof typeof icons
    color?: Colors
  }
  childrenMarginTop?: TShirtSize
}

export const PerCardInfo: FC<Props> = ({ heading, description, icon, children, childrenMarginTop = 'l' }) => {
  return (
    <Card bordered={false}>
      <PerFlexRow align="middle" noWrap>
        <PerButtonCircle
          variant="bold"
          color={icon && icon.color ? icon.color : 'warning'}
          icon={icon && icon.name ? icon.name : 'warning_fill'}
          mr="m"
          className="per-cardWithIcon--button"
        />

        <div>
          <PerText>{heading}</PerText>
          {description && (
            <PerText appearance="info" mt="xxxs">
              {description}
            </PerText>
          )}
        </div>
      </PerFlexRow>

      {children && <PerSpacer mt={childrenMarginTop}>{children}</PerSpacer>}
    </Card>
  )
}
